import request from '@/utils/requestSupplier'

// 商铺分类列表
export function shopClassifyList (params) {
  return request({
    url: '/mchtPlat/list',
    method: 'post',
    params
  })
}


// WEBPACK FOOTER //
// ./src/api/sellerCategory.js